import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';

import { AuthService } from '@services/auth/auth.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router,
    private storage: Storage,
    private navigationService: NavigationService,
    private platform: Platform,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.userInfo) {
      return Promise.all([
        this.authService.isLoggedIn(),
        this.storage.get('name'),
      ])
      .then(
        ([loggedIn, name]) => {
          if (!loggedIn) {
            this.authService.redirectPage = (next as any)._routerState.url;
            if (name) {
              this.navigationService.goToRoot('persistent-login');
              return false;
            }
            this.navigationService.goToRoot('start');
            return false;
          }
          return true;
      });
    } else {
      return true;
    }
  }
}
